<template>
  <div class="home">
    <div class="liveB">
      <div class="entTime" v-show="isEndTime">
        <!-- <img :src="endImgH5"> -->
        <img :src="coverUri">
        <div class="cover-over">
          <span>{{liveStr}}</span>
          <!-- <van-loading size="24px"></van-loading> -->
        </div>
      </div>
      <div class="entTime" v-show="isStartTime">
        <!-- <img :src="endImgH5"> -->
        <img :src="coverUri">
        <div class="cover-over">
          <van-loading size="24px">等待重新连接中...</van-loading>
        </div>
      </div>
      <!-- <div class="all" v-if="isShowTime == 1">
        <span>直播时间 : {{liveStart1}}</span>
      </div>
      <div class="all" v-if="isShowTime == 2">
        <span>已直播 : {{secondTime}}</span>
      </div> -->
      <div class="videobox">
        <div class="prism-player" id="player-con" v-show="isVideo1"></div>
      </div>
    </div>

    <div class="work_wrap">
      <div class="openappbox">
        <div class="msgbox-botton" v-if="openPopup == true">
          <span>打开中科名兽医APP,<strong>查看更多精彩</strong></span>
          <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
            <script type="text/wxtag-template">
              <style>.btn {height: 45px;}</style>
              <div class="btn">打开APP</div>
            </script>
          </wx-open-launch-app>
        </div>
        <div class="app-img" @click="openApp" v-else><img src="../../assets/liveimg/openapp.png"></div>
        <!-- <div class="app-img" @click="openPopup = true"><img src="../../assets/liveimg/openapp.png"></div> -->
      </div>
      <div class="work_top">
        <h2>
          <span>{{roomName}}</span>
        </h2>
      </div>
      <div class="work_anchor">
        <div class="work_anchor_img">
          <div class="anchor_img"><img :src="url"></div>
          <div class="anchor_content">
            <div class="anchor_name">{{anchor_name}}</div>
            <div class="anchor_profession">{{anchor_title}}</div>
          </div>
        </div>
        <div class="work_anchor_num">
          <div class="anchor_num">{{audience_num}}人参与</div>
        </div>
      </div>
      <div class="work_buttom">
        <h2>直播间公告</h2>
        <div class="notice-box">
          <!-- <img src="../../assets/liveimg/notice.svg">
          <span>课程简介</span> -->
        </div>
        <p v-html="roomDesc"></p>
        <div class="roomdescimg" v-for="(item,i) in descImgList" :key="i">
          <van-image :src="item"></van-image>
        </div>
      </div>
    </div>

    <!-- <div class="" v-else>
      <div class="live-info">
        <div class="live-anchor-info">
          <div class="anchor-info-img"><img :src="url"></div>
          <div class="anchor-info-text">{{anchor_name}}</div>
        </div>
        <div class="live-time-info">
          <div class="time-info-img">
            <img src="../../assets/liveimg/line.svg">
            <span>已直播{{secondTime}}</span>
          </div>
          <div class="time-info-text">{{audience_num}}人</div>
        </div>
      </div>
      <div class="openappbox openapp-back">
        <div class="app-img" @click="openPopup = true"><img src="../../assets/liveimg/openapp.png"></div>
      </div>
      <div class="message">
        <cube-scroll ref="scroll" :data="speak">
          <div class="message-box" v-for="(item,i) in speak" :key="i">
            <div class="message-img"><img :src="item.user.portrait"></div>
            <div class="message-info">
              <div class="message-info-name">{{item.user.name}}</div>
              <div class="message-info-text">{{item.content | expression}}</div>
            </div>
          </div>
        </cube-scroll>
      </div>
    </div> -->

    <!-- <van-overlay :show="openPopup" @click="openPopup = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="msgbox">
            <h3>直播邀请</h3>
            <p>该直播使用最新版中科名兽医APP观看</p>
            <p>体验会更好哦，快来看看吧！</p>
            <div class="openapp-button" @click="openApp"><img src="../../assets/liveimg/openapp-small.svg"></div>
          </div>
          <div class="old-close" @click="openPopup = false"><img src="../../assets/liveimg/close.svg"></div>
        </div>
      </div>
    </van-overlay> -->

    <!-- <div class="openapp" @click="openApp">
      <div class="openapp-box">
        <div class="openapp-img">
          <img src="../../assets/liveimg/logo.png">
          <span>打开中科名兽医APP</span>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
  import VueAliplayer from 'vue-aliplayer'
  import { appkey } from '@/api/path.js'
  import { iswx, wxshare, secondToDate } from '@/utils/utils.js'
  import { sharevideolive, getendtime } from '@/api/resetApi.js'

  export default {
    name: 'liveBroadcast',
    components: {
      'ali-player': VueAliplayer
    },
    inject: ['reload'],
    data(){
      return{
        text: '测试打开APP',
        ip: '',
        live_status: 0,
        isShowTime: '',
        url: '',
        urlimg: require('../../assets/liveimg/user.png'),
        live_type: '',
        anchor_name: '',
        isEndTime: false,
        isVideo1: true,
        isVideo2: false,
        isStartTime: false,
        roomId: '',
        share_user_id: '',
        liveData: [],
        playUri: '',
        prePlayUri: '',
        roomName: '',
        roomDesc: '',
        coverUri: '',
        liveUri: '',
        shareUri: '',
        liveStart: '',
        liveStart1: '',
        liveEnd: '',
        anchorUri: '',
        anchorName: '',
        audience_num: '',
        liveTime: '',
        endImgH5: '',
        timePlayUri: '',
        seeked: false,
        isvideonum: 1,
        starDate: null,
        endDate: null,
        giveTimer: null,
        video: null,
        player: null,
        openPopup: false,
        appkey: appkey,
        speak: [],
        emojiList: [],
        token: '',
        chatRoomId: '10010',
        isMessage: false,
        numLive: 1,
        liveStr: '直播结束',
        isPaly: '',
        anchor_title: '',
        secondTime: '',
        room_desc_img: '',
        descImgList: [],
        id: 'wxopenLanchAppId',
        appid: 'wxdc89dd9a7329fe47',
        wechatOpenAppData: '',
      }
    },
    created(){
      if (this.$route.query.token) {
        this.token = this.$route.query.token
      }
      this.roomId = this.$route.query.roomId
      this.chatRoomId = this.roomId;
      this.share_user_id = this.$route.query.share_user_id
      // this.ip = returnCitySN['cip']

      let json = {
        "type": "live",
        "linkId": this.roomId
      }
      this.wechatOpenAppData = JSON.stringify(json)
      if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        console.log('wechat',wechat)
        let judgewechat = wechat[1].split('.')
        // this.text = judgewechat
        if (judgewechat[0]>=8) {
          this.openPopup = true
        } else if(judgewechat[0]>=7){
          if(judgewechat[1]>=0){
              this.text = judgewechat
            if(judgewechat[2]>=12){
              this.openPopup = true
              console.log("当前符合 h5 打开指定app")
            }
          }
        }
      }

      this.shareVideoInfo()
      // this.client()
    },
    mounted() {
      // 检测断网
      window.addEventListener("offline", () => {
        console.log("已断网");
        // alert("已断网")
        this.isEndTime = true;
        this.isVideo1 = false;
        this.isShowTime = ''
        this.liveStr = '断网，请重新连接网络...'
      });
      window.addEventListener("online", () => {
        console.log("网络已连接");
        this.reload()
      });
      if (this.openPopup == true) {
        var btn = document.getElementById(this.id)
        btn.addEventListener('launch', e => {
          console.log('success');
        });
        btn.addEventListener('error',  e => {
          this.text = e.detail.errMsg
          if (e.detail.errMsg == 'launch:fail') {
            window.location = 'http://t.cn/Aijv8II4'
          } else {
            this.$createToast({
              txt: e.detail,
              type: 'error'
            }).show()
          }
        });
      }
    },
    methods: {
      // 获取直播信息
      async shareVideoInfo() {
        // console.log('ip=',this.ip)
        let data = {
          accessPort: 'pc',
          room_id: this.roomId,
          user_id: this.ip,
          share_user_id: this.share_user_id
        }
        const res = await sharevideolive(data)
        console.log(res)
        try {
          if (res.data.code === 1) {
            let reg = new RegExp("\r\n", "g");
            this.liveData = res.data.obj[0]
            this.url = this.liveData.anchor_img_uri?this.liveData.anchor_img_uri:this.urlimg
            this.anchor_title = this.liveData.anchor_title?this.liveData.anchor_title:''
            this.anchor_name = this.liveData.anchor_name?this.liveData.anchor_name:''
            this.playUri = this.liveData.h5_play_uri?this.liveData.h5_play_uri:''
            this.prePlayUri = this.liveData.pre_play_uri?this.liveData.pre_play_uri:''
            this.roomName = this.liveData.room_name?this.liveData.room_name:''
            this.roomDesc = this.liveData.room_desc.replace(reg, "<br/>")
            this.coverUri = this.liveData.cover_uri?this.liveData.cover_uri:''
            this.liveUri = this.liveData.live_cover_uri?this.liveData.live_cover_uri:''
            this.shareUri = this.liveData.share_img_uri?this.liveData.share_img_uri:''
            this.liveStart = this.liveData.live_start_time.replace(/-/g, "/")
            this.liveStart1 = this.liveData.live_start_time?this.liveData.live_start_time:''
            this.liveEnd = this.liveData.live_end_time.replace(/-/g, "/")
            this.anchorUri = this.liveData.anchor_img_uri?this.liveData.anchor_img_uri:''
            this.anchorName = this.liveData.anchor_name?this.liveData.anchor_name:''
            this.live_type = this.liveData.live_type?this.liveData.live_type:''
            this.audience_num = this.liveData.audience_num?this.liveData.audience_num:''
            this.live_status = this.liveData.live_status?this.liveData.live_status:''
            this.liveTime = this.liveData.live_time?this.liveData.live_time:''
            this.endImgH5 = this.liveData.live_end_img.live_end_img_h5?this.liveData.live_end_img.live_end_img_h5:''
            this.secondTime = secondToDate(this.liveTime)
            if (this.liveData.room_desc_img) {
              this.room_desc_img = this.liveData.room_desc_img
            }
            if (this.room_desc_img) {
              this.descImgList = this.room_desc_img.split(',')
            }
            // console.log('liveData=',this.liveData)
            // console.log('playUri=',this.playUri)
            // console.log('prePlayUri=',this.prePlayUri)

            // this.liveStart = ('2020-07-09 14:51:00').replace(/-/g, "/");
            // this.liveEnd = ('2020-07-10 16:28:00').replace(/-/g, "/");
            // console.log('22222222222')
            let videodesc = '授课人：'+this.liveData.anchor_name+'\r\n直播时间：'+this.liveData.live_start_time
            wxshare(this.shareUri,this.roomName,videodesc);
            // console.log('2222222222',this.getendtime())
            // this.getendtime()
            if (new Date(this.liveStart) > new Date()) {
              this.isEndTime = false;
              this.isVideo1 = true;
              this.isShowTime = 1
              this.timePlayUri = this.prePlayUri;
              this.picurl = this.coverUri;
              this.livePlayer(1)
              console.log('预告片开始')
            } else if (new Date(this.liveEnd) < new Date()) {
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isShowTime = ''
              this.liveStr = '直播结束'
              console.log('直播已结束')
            } else {
              this.isEndTime = false;
              this.isVideo1 = true;
              this.timePlayUri = this.playUri
              this.picurl = this.liveUri;
              this.isShowTime = 2
              this.livePlayer(2)
              console.log('正片开始')
            }
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // 获取直播结束时间
      async getendtime(that) {
        let data = {
          room_id: this.roomId
        }
        const res = await getendtime(data)
        console.log(res)
        try {
          if (res.data.code == 1) {
            clearInterval(this.endDate)
            clearInterval(this.giveTimer)
            this.liveEnd = res.data.live_end_time.replace(/-/g, "/")
            // this.liveEnd = ('2020-07-10 16:28:00').replace(/-/g, "/");
            console.log('endtime',this.liveEnd)
            // console.log('endtime',new Date())
            if (new Date(this.liveEnd) >= new Date()) {
              // this.endDate = setInterval(this.timerEnd,1000)
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isShowTime = ''
              this.liveStr = '网路不好请刷新页面重新连接...'

              // this.isStartTime = true;
              // this.isVideo1 = false;
              // setTimeout(function () {
              //   that.reload()
              // }, 10000);

              console.log('主播网路正在连接')
            } else {
              // this.reload()
              this.isEndTime = true;
              this.isVideo1 = false;
              this.isShowTime = ''
              this.liveStr = '直播结束'
              console.log('主播时间结束')
            }
          }
        } catch (error) {
          console.log('已经断网')
        }
      },
      // 播放直播
      livePlayer(type) {
        let that = this
        that.player = new Aliplayer({
          "id": "player-con",
          "source": that.timePlayUri,
          'cover': that.picurl,
          "width": "100%",
          "height": "100%",
          "autoplay": false,
          "isLive": true,
          "rePlay": false,
          "playsinline": true,
          "preload": true,
          disableSeek: true,
          "skinLayout": [{name: "bigPlayButton", align: "blabs", x: 0, y: 80}],
          // "controlBarVisibility": "hover",
          "controlBarVisibility":"always",
          "useH5Prism": true
        },function(player){
          let u = navigator.userAgent;
          let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          console.log('liveEnd=',that.liveEnd)
          if (type == 1) {
            if (new Date(that.liveStart) > new Date()) {
              that.starDate = setInterval(that.timerstar,1000)
            }
          } else if (type == 2) {
            // player.on('onM3u8Retry',function(){
            //   console.log('直播失败')
            //   if (that.numLive == 1) {
            //     that.getendtime(that)
            //   }
            //   that.numLive++
            // })
            player.on('liveStreamStop',function(){
              console.log('直播失败')
              if (that.numLive == 1) {
                that.getendtime(that)
              }
              that.numLive++
            })
            if (isIOS) {
              player.on('canplaythrough',function  (e) {
                if(!that.seeked) {
                  console.log('seeked1=',that.seeked)
                  console.log('liveTime1=',that.liveTime)
                  that.seeked = true;
                  if (parseInt(that.liveTime) > 0) {
                    // let num1 = 600
                    let num1 = parseInt(that.liveTime)
                    player.seek(num1)
                    player.play()
                    // player.on('play',function  (e) {
                    //   that.isShowTime = 2
                    //   alert(that.isShowTime)
                    // })
                  } else {
                    player.play()
                    // player.on('play',function  (e) {
                    //   that.isShowTime = 2
                    //   alert(that.isShowTime)
                    // })
                  }
                }
              });
            } else {
              console.log('seeked2=',that.seeked)
              console.log('liveTime2=',that.liveTime)
              if (parseInt(that.liveTime) > 0) {
                // let num = 400
                let num = parseInt(that.liveTime)
                player.seek(num)
                player.play()
                // player.on('play',function  (e) {
                //   that.isShowTime = 2
                // })
              } else {
                player.play()
                // player.on('play',function  (e) {
                //   that.isShowTime = 2
                // })
              }
            }
            if (new Date(that.liveEnd) > new Date()) {
              that.endDate = setInterval(that.timerEnd,1000)
              // that.giveTimer = setInterval(that.giveTimerData,10000)
            }
          }
        });
      },
      // 判断时间直播开始和直播结束
      timerstar() {
        console.log('1')
        if (new Date(this.liveStart)-new Date() <= 0) {
          this.reload()
          clearInterval(this.starDate)
          console.log('时间开始')
        }
      },
      timerEnd() {
        console.log('2')
        if (new Date(this.liveEnd)-new Date() <= 0) {
          this.reload()
          clearInterval(this.endDate)
          console.log('时间结束')
        }
      },
      giveTimerData() {
        console.log('3')
        if (new Date(this.liveEnd)-new Date() <= 0) {
          clearInterval(this.giveTimer)
          console.log('获取已直播时间结束')
        } else {
          this.giveTimeData()
        }
      },

      // 获取已直播时间
      async giveTimeData() {
        let data = {
          accessPort: 'pc',
          room_id: this.roomId,
          user_id: this.ip,
          share_user_id: this.share_user_id
        }
        const res = await sharevideolive(data)
        console.log('获取已直播时间')
        try {
          if (res.data.code === 1) {
            this.secondTime = secondToDate(res.data.obj[0].live_time)
          }
        } catch (error) {}
      },
      //
      openApp() {
        window.location = 'http://t.cn/Aijv8II4'
        // this.$router.push({
        //   name: 'OpenApp',
        //   query:{
        //     roomId: this.roomId,
        //   }
        // })
      },
      // 连接融云聊天室
      client() {
        let that = this
        // 表情包
        // RongIMLib.RongIMEmoji.init();
        // that.emojiList = RongIMLib.RongIMEmoji.list;
        // console.log('表情',that.emojiList)

        // 初始化
        RongIMLib.RongIMClient.init(that.appkey);

        // 状态监听器
        RongIMClient.setConnectionStatusListener({
          onChanged: function (status) {
            // status 标识当前连接状态
            switch (status) {
              case RongIMLib.ConnectionStatus.CONNECTED:
                console.log('链接成功');
                break;
              case RongIMLib.ConnectionStatus.CONNECTING:
                console.log('正在链接');
                break;
              case RongIMLib.ConnectionStatus.DISCONNECTED:
                console.log('断开连接');
                break;
              case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
                console.log('其他设备登录, 本端被踢');
                break;
              case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
                console.log('域名不正确, 请至开发者后台查看安全域名配置');
                break;
              case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
                console.log('网络不可用, 此时可调用 reconnect 进行重连');
                break;
              default:
                console.log('链接状态为', status);
                break;
            }
          }
        });

        // 消息监听器
        RongIMClient.setOnReceiveMessageListener({
          // 接收到的消息
          onReceived: function (message) {
            var messageContent = message.content;
            // console.log('1111111111111')
            // 判断消息类型
            switch(message.messageType) {
              case RongIMClient.MessageType.TextMessage: // 文字消息
                that.speak.push(messageContent)
                console.log('表情', RongIMLib.RongIMEmoji.symbolToEmoji(messageContent.content));
                console.log('文字内容', messageContent.content);
                console.log('集合', that.speak);
                break;
              case RongIMClient.MessageType.ImageMessage: // 图片消息
                console.log('图片缩略图 base64', messageContent.content);
                console.log('原图 url', messageContent.imageUri);
                break;
              case RongIMClient.MessageType.HQVoiceMessage: // 音频消息
                console.log('音频 type ', messageContent.type); // 编解码类型，默认为 aac 音频
                console.log('音频 url', messageContent.remoteUrl); // 播放：<audio src={remoteUrl} />
                console.log('音频 时长', messageContent.duration);
                break;
              case RongIMClient.MessageType.RichContentMessage: // 富文本(图文)消息
                console.log('文本内容', messageContent.content);
                console.log('图片 base64', messageContent.imageUri);
                console.log('原图 url', messageContent.url);
                break;
              case RongIMClient.MessageType.UnknownMessage: // 未知消息
                console.log('未知消息, 请检查消息自定义格式是否正确', message);
                break;
              default:
                console.log('收到消息', message);
                break;
            }
          }
        });

        // 连接接口
        let token = that.token
        // 开发者后台获取或 Server API
        RongIMClient.connect(token, {
          onSuccess: function(userId) {
            console.log('Connect successfully. ' + userId);
            that.chatRoom()
          },
          onTokenIncorrect: function() {
            console.log('token 无效');
          },
          onError: function(errorCode){
            var info = '';
            switch (errorCode) {
            case RongIMLib.ErrorCode.TIMEOUT:
              info = '超时';
              break;
            case RongIMLib.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
              info = '不可接受的协议版本';
              break;
            case RongIMLib.ConnectionState.IDENTIFIER_REJECTED:
              info = 'appkey不正确';
              break;
            case RongIMLib.ConnectionState.SERVER_UNAVAILABLE:
              info = '服务器不可用';
              break;
            }
            console.log('33333=',info);
          }
        });


      },
      // 加入聊天室
      chatRoom() {
        var chatRoomId = this.chatRoomId;
        var count = 10;
        RongIMClient.getInstance().joinChatRoom(chatRoomId, count, {
          onSuccess: function() {
            console.log('加入聊天室成功');
          },
          onError: function(error) {
            console.log('加入聊天室失败', error);
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  .home {
    max-width: 768px;
    margin: 0 auto;
  }
  .prism-player {
    z-index: 1;
  }
  .prism-info-display {
    padding: 0!important;
  }
  .prism-controlbar {
    display: none !important;
  }
  .prism-big-play-btn {
    left: 50%!important;
    top: 50%!important;
    margin-left: -32px!important;
    margin-top: -32px!important;
  }

  .openapp {
    position: fixed;
    width:3.9rem;
    bottom: 0;
    // left: 0;
    height: 0.5rem;
    vertical-align: top;
    line-height: 0.5rem !important;
    text-align: center !important;
    background: -webkit-linear-gradient(left, #0097e0 , #004ea2);
    // background: -o-linear-gradient(left, #0097e0, #004ea2);
    // background: -moz-linear-gradient(left, #0097e0, #004ea2);
    // background: linear-gradient(left,#0097e0, #004ea2);
    background-size:100% 100%;
    .openapp-box {
      display: inline-block;
      vertical-align: top;
    }
    .openapp-img {
      display: flex;
      align-self: center;
      width: 2rem;
      img {
        width: 0.36rem;
        height: 0.36rem;
        margin-top: 0.08rem
      }
      span {
        margin-left: 0.1rem;
        font-size: 0.14rem;
        color: #fff;
      }
    }
  }

  .live-info {
    display: flex;
    font-size: 0;
    color: #fff;
    padding: 0.1rem;
    background: #242424;
    .live-anchor-info {
      flex: 1;
      display: flex;
      .anchor-info-img {
        flex: 0 0 0.32rem;
        margin-left: 0.05rem;
        align-self: center;
        img {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      .anchor-info-text {
        flex: 1;
        margin-left: 0.1rem;
        align-self: center;
        text-align: left;
        font-size: 0.15rem;
        font-weight: 600;
      }
    }
    .live-time-info {
      flex: 1;
      display: flex;
      .time-info-img {
        flex: 1;
        align-self: center;
        padding-right: 0.05rem;
        border-right: 0.01rem solid #818181;
        img {
          width: 0.1rem;
          height: 0.08rem;
        }
        span {
          margin-left: 0.05rem;
          font-size: 0.1rem;
        }
      }
      .time-info-text {
        flex: 0 0 0.5rem;
        text-align: right;
        align-self: center;
        font-size: 0.1rem;
      }
    }
  }
  .openapp-back {
    background: #f4f4f4;
  }

  .work_top{
    margin: 0 0.15rem;
    padding-bottom: 0.15rem;
    border-bottom: 0.01rem solid #efefef;
    h2 {
      text-align: left;
      font-size: 0.18rem;
      .pic{
        width: 0.2rem;
        vertical-align: middle;
        margin-right: 0.05rem;
      }
      span {
        font-weight: 600;
      }
    }
  }

  .work_anchor {
    display: flex;
    padding: 0.1rem 0.15rem;
    border-bottom: 0.1rem solid #F5F5F5;
    .work_anchor_img {
      flex: 1;
      display: flex;
      align-self: center;
      text-align: left;
      font-size: 0;
      .anchor_img {
        flex: 0 0 0.4rem;
        img {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
        }
      }
      .anchor_content {
        flex: 1;
        align-self: center;
        margin-left: 0.05rem;
        .anchor_name {
          font-size: 0.15rem;
          font-weight: bold;
          color: #242424;
        }
        .anchor_profession {
          padding-top: 0.05rem;
          font-size: 0.12rem;
          color: #999999;
        }
      }
    }
    .work_anchor_num {
      flex: 0 0 1rem;
      align-self: center;
      text-align: right;
      font-size: 0;
      .anchor_num {
        display: inline-block;
        padding: 0.06rem 0.1rem;
        text-align: center;
        border-radius: 0.12rem;
        font-size: 0.12rem;
        font-weight: 400;
        color:#fff;
        background: linear-gradient(to left,#127be4, #00a4ff);
      }
    }
  }
  .work_buttom {
    padding: 0.2rem 0 0.5rem 0.15rem;
    h2 {
      text-align: left;
      padding-bottom: 0.16rem;
      font-size: 0.15rem;
      font-weight: bold;
      color: #242424;
      border-bottom: 0.01rem solid #efefef;
    }
    .notice-box {
      padding: 0.14rem 0 0.1rem;
      font-size: 0;
      text-align: left;
      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.02rem;
        font-size: 0.14rem;
        font-weight: bold;
        vertical-align: middle;
      }
    }
    p {
      text-align: left;
      padding: 0 0.1rem 0.06rem 0;
      font-size: 0.12rem;
      line-height: 0.2rem;
      color: #4a4a4a;
    }
    .roomdescimg {
      padding-right: 0.15rem;
      img {
        width: 100%;
      }
    }
  }
  .liveB {
    position: relative;
    height: 2.6rem;
    background: #000;
    .all {
      position: absolute;
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      text-align: left;
      bottom: 0px;
      right: 0px;
      z-index: 3;
      font-size: 0;
      background: rgba(0,0,0, 0.5);
      span {
        margin-left: 0.1rem;
        font-size: 0.14rem;
        font-weight: 500;
        color: #fff;
      }
    }
    .videobox {
      height: 2.6rem;
      z-index: 2;
    }
  }

  .entTime{
    width: 100%;
    height: 2.6rem;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 2.6rem;
    }
    .cover-over {
      width: 100%;
      height: 2.6rem;
      line-height: 2.2rem;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba($color: #000000, $alpha: 0.6);
      span {
        font-size: 0.14rem;
        font-weight: 600;
        color: #fff;
        letter-spacing: 0.03rem;
      }
    }
  }

  .video_rgba{
    width:100%;
    height: 2.6rem;
    position: absolute;
    top:0;
    left: 0;
    background: url("../../assets/liveimg/aaa.png");
    z-index: 999;
    text-align: center;
    display: none;
  }
  .video_rgba p{
    font-size: 0.14rem;
    margin-top: 0.9rem;
    color:#fff;
    margin-bottom: 0.25rem;
  }
  .video_rgba button{
    background: none;
    background: #0097E0;
    font-size: 0.14rem;
    border:none;
    border-radius: 0.20rem;
    padding: 0.1rem 0.4rem;
    color:#fff;
  }

  .videonav {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 0.4rem;
    color: #fff;
    background: #000;
  }
  .van-overlay {
    z-index: 9999;
    top: 30px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 0;
    z-index: 9999;
  }

  .block {
    font-size: 0;
    text-align: center;
    .msgbox {
      width: 3rem;
      padding: 0.2rem 0 0.14rem;
      background-color: #fff;
      border-radius: 0.1rem;
      h3 {
        text-align: center;
        font-size: 0.15rem;
        font-weight: bold;
        padding-bottom: 0.2rem;
      }
      p {
        padding-bottom: 0.01rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        font-size: 0.14rem;
        color: #333;
        font-weight: 400;
      }
      .openapp-button {
        display: inline-block;
        padding-top: 0.2rem;
        width: 2.3rem;
        height: 0.54rem;
        img {
          width: 100%;
        }
      }
    }
    .old-close {
      display: inline-block;
      margin-top: 0.2rem;
      width: 0.35rem;
      height: 0.35rem;
      img {
        width: 0.35rem;
        height: 0.35rem;
      }
    }
  }

  .message {
    background: #f4f4f4;
    height: 2.7rem;
    .message-box {
      display: flex;
      padding: 0.1rem;
      font-size: 0;
      .message-img {
        flex: 0 0 0.3rem;
        img {
          width: 0.3rem;
          height: 0.3rem;
          border-radius: 50%;
          vertical-align: top;
        }
      }
      .message-info {
        flex: 1;
        margin-left: 0.05rem;
        display: flex;
        border-radius: 0.12rem;
        font-size: 0;
        background: #fff;
        .message-info-name {
          flex: 0 0 0.4rem;
          padding: 0.12rem 0.05rem;
          align-self: top;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          // vertical-align: top;
          font-size: 0.12rem;
          color: #707070;
        }
        .message-info-text {
          flex: 1;
          padding: 0.1rem 0.05rem;
          line-height: 0.15rem;
          text-align: left;
          align-self: center;
          font-size: 0.12rem;
          color: #252525;
        }
      }
    }
  }

  .openappbox {
    padding: 0.15rem;
    text-align: center;
    font-size: 0;
    .app-img {
      display: inline-block;
      width: 100%;
      height: 0.54rem;
      img {
        width: 100%;
      }
    }
  }
  .msgbox-botton {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 0.45rem;
    background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
    border-radius: 0.04rem;
    font-size: 0.15rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 0.45rem;
    strong {
      margin-left: 0.2rem;
    }
    .launch-btn {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      opacity: 0;
    }
  }

</style>
